// src/lib/feature-seen.ts
// Utilidad genérica para el punto de "no visto" en el avatar del dashboard — no está
// atada a una función específica, cualquier feature nueva puede usar su propia `key`.
// Cliente-only (cookie no-httpOnly, de un año, solo marca "ya lo abrí una vez").
"use client";

const COOKIE_PREFIX = "snapsite_seen_";
const MAX_AGE_SECONDS = 60 * 60 * 24 * 365; // 1 año

function cookieName(featureKey: string): string {
  return `${COOKIE_PREFIX}${featureKey}`;
}

export function hasSeenFeature(featureKey: string): boolean {
  if (typeof document === "undefined") return true; // SSR: no mostrar el punto de más
  return document.cookie
    .split("; ")
    .some((c) => c.startsWith(`${cookieName(featureKey)}=1`));
}

export function markFeatureSeen(featureKey: string): void {
  if (typeof document === "undefined") return;
  document.cookie = `${cookieName(featureKey)}=1; path=/; max-age=${MAX_AGE_SECONDS}; SameSite=Lax`;
}

// Keys de features individuales — centralizadas aquí para que el componente que marca
// "visto" y el que muestra el punto usen exactamente la misma cadena.
export const REFERRAL_FEATURE_KEY = "referral-2026-08";
export const PROFILE_CARD_FEATURE_KEY = "profile-card-2026-09";
export const GALLERY_FEATURE_KEY = "gallery-2026-09";
